import ComingSoonPage from "../../components/ComingSoonPage";
import AppShell from '../../components/AppShell';

export default function MeetGenie() {
  return (
    <AppShell>
      <div className="lg:col-span-8 space-y-6 text-center">
    <ComingSoonPage
      appName="Meet Genie AI"
      teaser="Auto-schedule, pre-brief, and summarize meetings with AI."
      imageSrc="/images/coming-soon/trendpulse.png"
    />
    </div>
    </AppShell>
  );
}

